export class RequestLogin {
    isFirstLogin: boolean;
    memberCode: string;
    sessionId: string;
}

export class OTPInfo {
    Otp :string
    OtpRequestTime :string
    OtpResponseTime:string
}